const actions = {
  SET_IS_MAP_PAGE: "SET_IS_MAP_PAGE",
  SET_NEW_MSGS_COUNT: "SET_NEW_MSGS_COUNT",
  SET_CHART_JS_LOADED: "SET_CHART_JS_LOADED",
  SET_IS_DAILY_RENT_PAGE: "SET_IS_DAILY_RENT_PAGE",
  setIsMapPage: (payload) => ({
    type: actions.SET_IS_MAP_PAGE,
    payload,
  }),
  setIsDailyRentPage: (payload) => ({
    type: actions.SET_IS_DAILY_RENT_PAGE,
    payload,
  }),
  setNewMsgsCount: (payload) => ({
    type: actions.SET_NEW_MSGS_COUNT,
    payload,
  }),
  setChartJsLoaded: (payload) => ({
    type: actions.SET_CHART_JS_LOADED,
    payload,
  }),
};

export default actions;
